












import { Vue, Component, Prop } from 'vue-property-decorator';
import CandidatePortalLogo from '@/components/CandidatePortalLogo.vue';
@Component({
  components: {
    CandidatePortalLogo,
  },
})
export default class Header extends Vue {
  @Prop({ default: true }) showImage;
  @Prop({ default: '' }) formName;
}
